import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { from, Observable, of, switchMap } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { DocPreviewUtilityService } from '../doc-preview-utility.service';
import { EXTENSIONS } from '../eml/eml-preview.component';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';

@Injectable({
  providedIn: 'root'
})
export class PdfPreviewResolver implements Resolve<boolean> {
  constructor(
    private helpers: HelpersService,
    private docUtilityService: DocPreviewUtilityService,
    private router: Router
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let refDocumentale = route.paramMap.get('refDocumentale')!;
    let idDocument = route.paramMap.get('idDocumento')!;
    let type = route.paramMap.get('type')!;
    let versione = route.paramMap.get('versione')!;
    if(!!refDocumentale) {
      return this.pdfPreviewRefDocumentale(refDocumentale);
    } else if(!!idDocument) {
      if (type === "p7m") {
        return this.helpers.extractPdfFromP7mDocAllegata(idDocument, versione).pipe(
          switchMap(res => {
            if (!!res) {
              const contentDisposition = res.headers.get('Content-Disposition');
              const { filename, extension } = this.docUtilityService.parseContentDisposition(contentDisposition);
              if(extension.toLowerCase() === "pdf") {
                return of(res.body);
              } else {
                this.previewNavigate(idDocument, extension, filename);
                return of(false);
              }
            } else {
              return of(false);
            }
          })
        );
      } else {
        if (idDocument === "buffer") {
          return of(true);
        }
        return this.pdfPreview(idDocument)
      }
    }
  }

  private pdfPreviewRefDocumentale(refDocumentale):Observable<boolean | any> {
    if (refDocumentale === "buffer") {
      return of(true);
    } 
    return this.getPdfPreviewByRef(refDocumentale);
  }

  private getPdfPreviewByRef(refDocumentale: string) {
    return this.helpers.showPreviewWithRefDocumentale(refDocumentale).pipe(
      switchMap(res => {
        if (!!res) {
          return of(res.body);
        } else {
          return of(false);
        }
      })
    );
  }

  

  private pdfPreview(idDocument: string): Observable<any> {
    return this.helpers.getPreview(idDocument).pipe(
      switchMap(res => {
        if (!!res) {
          return of(res.body);
        } else {
          return of(false);
        }
      })
    );
  }

  private previewNavigate(docId, contentType: string, filename:string) {
      let fullUrl = null;
      let urlTree = null;
      let urlSerialized = null;
      switch (contentType) {
        case EXTENSIONS.EML:
          urlTree = this.router.createUrlTree([UrlSettingsCore.URL_EML_FILE_PREVIEW, docId]);
          break;
        case EXTENSIONS.ZIP:
          urlTree = this.router.createUrlTree([UrlSettingsCore.URL_ZIP_FILE_PREVIEW, docId]);
          break;
        default:
          alert("Anteprima non supportata per questo documento")
          break;
      }
      if(!urlTree) return;
      urlSerialized = this.router.serializeUrl(urlTree);
      fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}?nomeFile=${filename}`;
      window.open(fullUrl, '_blank');
    }
}
